// extracted by mini-css-extract-plugin
export default {"victoryPointsContainer":"victoryPointsContainer-P2GekwRc","largeRibbon":"largeRibbon-PQKt_w4_","victoryPoints":"victoryPoints-u0xGd7sj","ribbon":"ribbon-lTUSyke_"};